// icon.js
import React from "react";
import IcoMoon, { IconProps } from "react-icomoon";
import iconSet from "./selection.json";

const Icon = ({ size = "auto", ...props }: IconProps) => {
	return <IcoMoon aria-hidden="true" iconSet={iconSet} size={size} {...props} />;
};

export default Icon;